var path = process.env.REACT_APP_API_PATH;
//var path = 'http://localhost:5005/api/';

var config = {
    register: path
};

export default config;
